import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../../components/header';
import Footer from '../../../components/footer';
import Banner from '../../../assets/images/banner-covid-transp.jpg';
import Head from '../../../components/head';
import Item from '../../../components/itens/item'


function CovidScreen() {
    return (
        <Fragment>
            <Head titulo="COVID-19 - Portal da Transparência do Município de Macuco" />
            <Header />
            <img style={{
                maxWidth: '90%',
                display: 'block',
                margin: '1rem auto'
            }} src={Banner} alt="Acompanhe as ações da Prefeitura de Macuco contra o COVID-19" />
            <Container>
                <Row xs={1} lg={3}>
                    <Col>
                        <Item
                            titulo={"Boletins"}
                            descricao={"Notícias e informativos sobre o Coronavírus incluindo os boletins epidemiológicos."}
                            img={"../images/icons/noticias-icon.png"}
                            link={"https://prefeituramacuco.rj.gov.br/site/covid"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Leis e Decretos"}
                            descricao={"Leis, decretos e demais espécies normativas do Município referentes ao combate do Coronaírus."}
                            img={"../images/icons/leis-icon.png"}
                            link={"../leis/covid"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Dispensas Emergenciais"}
                            descricao={"Informações referentes as dispensas emergenciais feitas no combate ao Coronavírus."}
                            img={"../images/icons/licitacoes-icon.png"}
                            link={"../licitacao/dispensa-covid"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Licitações"}
                            descricao={"Informações referentes as licitações relacionadas com as ações de combate ao Coronavírus."}
                            img={"../images/icons/licitacoes-icon.png"}
                            link={"../licitacao/covid"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Contratos"}
                            descricao={"Informações referentes aos contratos de licitações relacionadas com as ações de combate ao Coronavírus."}
                            img={"../images/icons/licitacoes-icon.png"}
                            link={"../contratos/covid"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Perguntas e Respostas"}
                            descricao={"Tem dúvidas sobre o CORONAVÍRUS? Veja a cartilha do Ministério da Saúde."}
                            img={"../images/icons/pergunta-icon.png"}
                            link={"../arquivos/docs/cartilha_coronavirus.pdf"}
                            key={1}
                        />
                    </Col>
                </Row>

                <Link to='/saude'>
                    <Button type='button' variant='danger'>Voltar</Button>
                </Link>

            </Container>
            <Footer />
        </Fragment>
    );
}

export default CovidScreen;